// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KpFpR{position:relative;display:inline-flex;align-items:center;gap:4px;height:32px;padding:4px 12px;border:1px solid #282863;border-radius:999px;background-color:#fcfcfd}.KpFpR.yiMZP{border-color:#fadea8;background-color:#fdf2dc}.KpFpR:hover .tYf_z{opacity:1}.GJ5bY{color:#282863;white-space:nowrap}.FkkPd{display:inline-flex;align-items:center;padding:2px 8px;border-radius:999px;background-color:#f4f4f7;color:#696992;white-space:nowrap}.KpFpR.yiMZP .FkkPd{background-color:#fadea8}.FkkPd.RlSj4{cursor:pointer;transition:background-color .1s ease,color .1s ease}.FkkPd.RlSj4:hover{background-color:#bfbfd0;color:#282863}.KpFpR.yiMZP .FkkPd.RlSj4:hover{background-color:#f9d797}.vmOHr{color:inherit}.F7ayt{white-space:nowrap}.fQeYc{color:#9393b1;white-space:nowrap}.tYf_z{position:absolute;top:-6px;right:-6px;display:inline-flex;align-items:center;justify-content:center;width:16px;height:16px;border-radius:50%;border:1px solid #bfbfd0;background-color:#fff;color:#282863;opacity:0;transition:opacity .1s ease}.tYf_z button{width:100%;height:100%;min-width:0;min-height:0;padding:0;color:#282863}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"root": `KpFpR`,
	"settings": `yiMZP`,
	"removeButton": `tYf_z`,
	"field": `GJ5bY`,
	"value": `FkkPd`,
	"clickable": `RlSj4`,
	"valueText": `vmOHr`,
	"valuePrefix": `F7ayt`,
	"combinator": `fQeYc`
};
export default ___CSS_LOADER_EXPORT___;
